import React, { useState, useEffect, useCallback } from 'react';
import { Grid, TextField } from '@nextiva/next-ui-components';

import { EDIT_ROLE, SUPER_ADMIN, CLONE_ROLE } from 'constants/drawerTitles';

import RoleTabs from './RoleTabs';

const RoleForm = ({
  role,
  drawerTitle,
  roleNameError,
  roleRequestBody: { name },
  setRoleNameError,
  updateRoleRequestBodyName,
}) => {
  const [disabled, setDisabled] = useState(false);

  /**
   * role name are cleared by closing the drawer
   * with the X and by using the cancel button
   */
  useEffect(() => {
    if (!role) return;

    switch (true) {
      case drawerTitle === CLONE_ROLE:
        setRoleNameError('Enter a role name.');
        break;
      case drawerTitle === EDIT_ROLE:
        updateRoleRequestBodyName(role.name);
        break;
      case drawerTitle === SUPER_ADMIN:
        setDisabled(true);
        updateRoleRequestBodyName(role.name);
        break;
      default:
        setDisabled(true);
        updateRoleRequestBodyName(role.name);
    }
  }, [drawerTitle]);

  const handleChangeRoleName = useCallback(
    (event) => {
      updateRoleRequestBodyName(event.target.value);
      setRoleNameError('');
    },
    [name],
  );

  return (
    <div
      className="m-role-form"
      data-testid="PlatformAdminUI-RolesAndPermissions-RoleForm-Form"
    >
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <div className="m-role-form__role-name">
            <TextField
              id="role-name"
              fullWidth
              error={!!roleNameError}
              helperText={!!roleNameError && roleNameError}
              label="Role Name"
              value={name}
              onChange={handleChangeRoleName}
              disabled={disabled}
              inputProps={{
                'data-testid':
                  'PlatformAdminUI-RolesAndPermissions-RoleForm-RoleName',
              }}
              data-testid="PlatformAdminUI-RoleForm-TextField"
            />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        <Grid item xs={12} className="m-tabs">
          <RoleTabs />
        </Grid>
      </Grid>
    </div>
  );
};

export default RoleForm;
